import { render, staticRenderFns } from "./SideColumn.vue?vue&type=template&id=33f9f3b1&lang=html&"
import script from "./SideColumn.vue?vue&type=script&lang=js&"
export * from "./SideColumn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/custom/abbrasil/spa/tipo-orcamento/SideColumn.vue
// module id = 1542
// module chunks = 28